import { useEffect, useState } from 'react';

/**
 * Debounce di un valore. Utile sui filtri testuali per evitare
 * una chiamata API per ogni tasto digitato.
 *
 * @example
 *   const [text, setText] = useState('');
 *   const debounced = useDebounce(text, 300);
 *   useEffect(() => fetch(...), [debounced]);
 */
export function useDebounce<T>(value: T, delay = 300): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debounced;
}
